import React from "react";

const DashboardHeader = () => {
    return (

        <nav className="navbar header-navbar pcoded-header">
            <div className="navbar-wrapper">

                <div className="navbar-logo">
                    <a className="mobile-menu" id="mobile-collapse" href="#!">
                        <i className="feather icon-menu"></i>
                    </a>
                    <a href="index-1.htm">
                        <img className="img-fluid" src="/libraries/assets/images/logo.png" alt="Theme-Logo"/>
                    </a>
                    <a className="mobile-options">
                        <i className="feather icon-more-horizontal"></i>
                    </a>
                </div>

                <div className="navbar-container container-fluid">
                    <ul className="nav-left">
                        <li className="header-search">
                            <div className="main-search morphsearch-search">
                                <div className="input-group">
                                    <span className="input-group-addon search-close"><i className="feather icon-x"></i></span>
                                    <input type="text" className="form-control"/>
                                    <span className="input-group-addon search-btn">
                                            <i className="feather icon-search"></i></span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <a href="#!" onclick="javascript:toggleFullScreen()">
                                <i className="feather icon-maximize full-screen"></i>
                            </a>
                        </li>
                    </ul>

                </div>
            </div>
        </nav>
    );
};

export default DashboardHeader;